import { cx } from "../../lib/cx";
import { base } from "../../lib/links";

/** Xeratec wordmark linking home. `tone="light"` is for dark grounds. */
export default function Logo({ tone = "dark", className, ...props }) {
  return (
    <a href={base} className="block shrink-0" {...props}>
      <img
        src={`${base}brand/logo-on-${tone === "light" ? "dark" : "light"}.png`}
        alt="Xeratec"
        width="640"
        height="95"
        className={cx("h-[30px] w-auto sm:h-[34px]", className)}
      />
    </a>
  );
}
